/* tslint:disable */
/* eslint-disable */
export enum CommunicationEnum {
  Email = 'Email',
  Post = 'Post'
}
